import React from "react"
import { AppButtonIcon } from "@components"
import { isOpenProvidersSuppliersMappingModal, selectedTable } from "Pages/Admin/ProvidersSuppliersMapping/@signals"

export default function MultiProvidersSuppliersMappingTableToolbar({ type, selectedData, setSelectedRows }) {

	return <AppButtonIcon
		icon="pen"
		tooltip="Edit selected mappings"
		sx={{ mr: 1 }}
		onClick={() => {
			isOpenProvidersSuppliersMappingModal.value = selectedData
			selectedTable.value = type
			setSelectedRows([])
		}}
	/>
}